var _defs, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveCommand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-47b545bc-7f94-4a03-8073-873eb62951d9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-9bfbc6dc-e4ef-493e-b324-994a172cbfaf {\n        fill: #f2f2f2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-9bfbc6dc-e4ef-493e-b324-994a172cbfaf",
    points: "16 14.22 18.42 10.04 13.58 10.04 16 14.22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9bfbc6dc-e4ef-493e-b324-994a172cbfaf",
    d: "M20.76,22.96h-9.52c-1.26,0-2.28-1.02-2.28-2.28v-3.43c0-1.26,1.02-2.28,2.28-2.28h9.52c1.26,0,2.28,1.02,2.28,2.28v3.43c0,1.26-1.02,2.28-2.28,2.28ZM11.24,16.97c-.16,0-.28.13-.28.28v3.43c0,.16.13.28.28.28h9.52c.16,0,.28-.13.28-.28v-3.43c0-.16-.13-.28-.28-.28h-9.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCommand);
export default __webpack_public_path__ + "static/media/SaveCommand.199335228507827bc1ea00ba8379aab8.svg";
export { ForwardRef as ReactComponent };